import { useState } from "react";
import { motion } from "framer-motion";
import { INDUSTRIES } from "../../data/site";

export default function Industries() {
  const [active, setActive] = useState(INDUSTRIES[0].key);
  const current = INDUSTRIES.find((i) => i.key === active);

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-24 md:py-36 border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#FF331F]" />
              <span className="font-mono-ibm text-[11px] tracking-[0.2em] uppercase text-[#FF331F]">
                Industries / 03
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] font-medium">
              Where we work.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-4">
            <p className="text-lg text-[#404040]">
              Specialist domain experience compounded across regulated, high-stakes
              sectors — applied with restraint and discipline.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-black/10 border border-black/10">
          {/* Tab list */}
          <div className="lg:col-span-4 bg-white">
            {INDUSTRIES.map((ind) => {
              const isActive = ind.key === active;
              return (
                <button
                  key={ind.key}
                  data-testid={`industry-tab-${ind.key}`}
                  onClick={() => setActive(ind.key)}
                  className="w-full text-left flex items-center justify-between px-6 md:px-8 py-5 border-b border-black/10 last:border-b-0 transition-colors"
                  style={{
                    backgroundColor: isActive ? ind.accent : "transparent",
                    color: isActive ? "#ffffff" : "#0A0A0A",
                  }}
                >
                  <span className="font-display text-xl md:text-2xl tracking-tight">
                    {ind.label}
                  </span>
                  <span
                    className="font-mono-ibm text-xs"
                    style={{
                      color: isActive ? "#ffffff" : ind.accent,
                    }}
                  >
                    →
                  </span>
                </button>
              );
            })}
          </div>

          {/* Content panel */}
          <div className="lg:col-span-8 bg-white p-8 md:p-14 min-h-[420px] relative">
              <motion.div
                key={current.key}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              >
                <div
                  className="font-mono-ibm text-xs uppercase tracking-widest"
                  style={{ color: current.accent }}
                >
                  [ {current.label} ]
                </div>
                <h3 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
                  {current.headline}
                </h3>
                <ul className="mt-10 space-y-4">
                  {current.points.map((p, i) => (
                    <li
                      key={p}
                      className="flex items-start gap-4 border-t border-black/10 pt-4"
                    >
                      <span
                        className="font-mono-ibm text-xs pt-1.5"
                        style={{ color: current.accent }}
                      >
                        0{i + 1}
                      </span>
                      <span className="text-base md:text-lg text-[#0A0A0A]">
                        {p}
                      </span>
                    </li>
                  ))}
                </ul>
              </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
